import { createReducer } from "redux-starter-kit";
import { switchZoomAction, noZoomAction } from "../actions/pdfEditTocContainer";

const INIT_STATE = {
  zoomed: false
};

const pdfEditTocContainer = createReducer(INIT_STATE, {
  [switchZoomAction]: (state, action) => {
    state.zoomed = !state.zoomed;
  },
  [noZoomAction]: (state, action) => {
    state.zoomed = false;
  }
});

export default pdfEditTocContainer;
